
/**
 * Dependencies:
 *  - jQuery
 */

const Navigation = {

    init: () => {
        const header = jQuery('.header');
        jQuery(window).on('scroll load', function() {
            const scrollFromTop = jQuery(window).scrollTop();
            if (scrollFromTop >= 100) {
                header.addClass('is-sticky');
            } else {
                header.removeClass('is-sticky');
            }
        });

		jQuery('.js-toggle-menu').click(function() {
			jQuery(this).toggleClass('show');
			jQuery('.book-now-btn').toggleClass('open');
			jQuery('#menu').toggleClass('show');
		});

    }
}

export default Navigation;
